export default __webpack_public_path__ + "static/media/newera.2b58d64f.jpg";